import { render, staticRenderFns } from "./Tests.vue?vue&type=template&id=0ec38c6d&scoped=true"
import script from "./Tests.vue?vue&type=script&lang=js"
export * from "./Tests.vue?vue&type=script&lang=js"
import style0 from "./Tests.vue?vue&type=style&index=0&id=0ec38c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec38c6d",
  null
  
)

export default component.exports